import { render, staticRenderFns } from "./EndpointsStatus.vue?vue&type=template&id=4e2221c2&scoped=true&"
import script from "./EndpointsStatus.vue?vue&type=script&lang=js&"
export * from "./EndpointsStatus.vue?vue&type=script&lang=js&"
import style0 from "./EndpointsStatus.vue?vue&type=style&index=0&id=4e2221c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2221c2",
  null
  
)

export default component.exports